import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  key: 0,
  class: "buttons-wrap"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Новые данные для входа ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ссылка для активации ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Добавить тариф ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Заблокировать ")
const _hoisted_11 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_12 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, " ID ", -1)
const _hoisted_16 = { class: "d-flex align-items-center gap-2" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "mb-0 pl-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 cursor-pointer" }, [
    /*#__PURE__*/_createElementVNode("span", null, " Активен ")
  ])
], -1)
const _hoisted_20 = { class: "mb-0 pl-2 text-center w-100" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_22 = {
  key: 0,
  class: "mb-0 mt-2 pl-2 text-center w-100"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-danger cursor-pointer" }, " Забанен ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, " PRO ", -1)
const _hoisted_25 = { class: "mb-0 pl-2 text-center w-100" }
const _hoisted_26 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, " Пользователь ", -1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "bordered w-100" }
const _hoisted_30 = { colspan: "2" }
const _hoisted_31 = { class: "paragraph my-1 mx-3 d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5" }, null, -1)
const _hoisted_33 = { style: {"padding-left":"6px"} }
const _hoisted_34 = { colspan: "2" }
const _hoisted_35 = { class: "paragraph my-1 mx-3 d-flex align-items-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill fs-5" }, null, -1)
const _hoisted_37 = { colspan: "2" }
const _hoisted_38 = { class: "paragraph my-1 mx-3" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Все объявления пользователя ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph my-1 mx-3" }, " Создан ")
], -1)
const _hoisted_41 = { class: "w-50" }
const _hoisted_42 = { class: "paragraph my-1 mx-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph my-1 mx-3" }, " Изменен ")
], -1)
const _hoisted_44 = { class: "paragraph my-1 mx-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph my-1 mx-3" }, " Авторизация ")
], -1)
const _hoisted_46 = { class: "paragraph my-1 mx-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 text-center" }, " Модерация ", -1)
const _hoisted_48 = { class: "mb-2 w-180px" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_52 = {
  href: "#",
  target: "_blank",
  class: "mb-0"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, " Не одобрялся ", -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_59 = { class: "mb-2" }
const _hoisted_60 = {
  href: "#",
  target: "_blank",
  class: "mb-0"
}
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", null, " Не отклонялся ", -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", null, " Email ", -1)
const _hoisted_65 = { class: "mb-0 pl-2 text-center w-100 leading-1" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 cursor-pointer text-center" }, " Создан ", -1)
const _hoisted_67 = { class: "mb-0 pl-2 w-100 leading-1" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, [
  /*#__PURE__*/_createTextVNode(" Последняя"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("авторизация ")
], -1)
const _hoisted_69 = { class: "mb-0 pl-2 w-100 leading-1" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", null, " Изменён ", -1)
const _hoisted_71 = { class: "mb-0 pl-2 w-100 leading-1" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 text-center" }, " Контент ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h4", { class: "h4" }, " Объявления ", -1)
const _hoisted_74 = { class: "mb-0" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("strong", null, " Активные: ", -1)
const _hoisted_76 = { class: "" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("strong", null, " Отклонённые: ", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 text-center" }, " Комментарии ", -1)
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill fs-3 text-primary" }, null, -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
  title: "Редактировать пользователя"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "bi-pencil-square fs-3 text-success" }, null, -1)
const _hoisted_85 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary",
  title: "Все объявления пользователя"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-lines-fill fs-3 text-success" }, null, -1)
const _hoisted_87 = ["disabled", "onClick"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-door-open-fill fs-3 text-info" }, null, -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  class: "buttons-wrap"
}
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" Новые данные для входа ")
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Ссылка для активации ")
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Добавить тариф ")
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" Заблокировать ")
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__title" }, "Продлить", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__hint" }, " Тот же тариф продлевается в конец цепочки, другой тариф заменяет текущий ", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__title" }, "Новый период", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__hint" }, " Все действующие платные периоды завершаются, создаётся один новый ", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__title" }, "Изменить текущий", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "tariff-modes__hint" }, " Меняется срок действующего периода этого тарифа, дата начала сохраняется. Если такого периода нет — как «Новый период» ", -1)
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Дней")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Месяцев")
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Отмена")
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" Применить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_BasePhoneText = _resolveComponent("BasePhoneText")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_users_filter = _resolveComponent("users-filter")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_pre, {
        hide: "",
        title: "usersFilterData",
        data: _ctx.usersFilterData
      }, null, 8, ["data"]),
      _createVNode(_component_base_pre, {
        hide: "",
        title: "itemsList",
        data: _ctx.itemsList
      }, null, 8, ["data"]),
      _createVNode(_component_users_filter, {
        onFilterUsersButtonClick: _ctx.filterUsersButtonClick,
        "items-total": _ctx.totalItems,
        "pages-total": _ctx.totalPages,
        "current-page": _ctx.usersFilterData.page
      }, {
        default: _withCtx(() => [
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allowEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "warning",
                  title: _ctx.rejectButtonTitle,
                  disabled: _ctx.bulkRejectStatus,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rejectEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetPasswordBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sentAccountConfirmLinkBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Добавить тариф выбранным пользователям'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openTariffDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Заблокировать пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.banEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _ctx.itemsList,
            "scrollbar-always-on": true,
            "table-layout": "fixed",
            "show-header": true,
            resizable: true
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, {
                "image-size": 300,
                description: "Ничего не найдено"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "top",
                class: "py-5 px-0 fw-bolder text-center min-w-50px align-top",
                width: _ctx.calcWidth(50),
                property: "checked"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.itemsList.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedModel) = $event)),
                          class: "form-check-input",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.switchAllCheckboxes && _ctx.switchAllCheckboxes(...args)))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.checkedModel]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((scope.row.checked) = $event),
                      class: "form-check-input"
                    }, null, 8, _hoisted_13), [
                      [_vModelCheckbox, scope.row.checked]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                property: "id",
                label: "ID",
                width: _ctx.calcWidth(110)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortTheColumn('id')))
                    }, [
                      _hoisted_15,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x", [
                      _ctx.sortState.id.dir ? 'bi-sort-up' : 'bi-sort-down',
                      _ctx.currentSort === 'id' || _ctx.currentSort === '-id'
                        ? 'text-success'
                        : 'opacity-25 text-black',
                    ]])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x mr-2", {
                      'bi-patch-check-fill text-primary':
                        scope.row.status === 'confirmed',
                      'bi-patch-minus-fill text-danger':
                        scope.row.status === 'rejected',
                      'bi-patch-exclamation-fill text-warning':
                        scope.row.status === 'not_verified',
                    }]),
                        title: _ctx.generateNewsTitle(scope.row.status)
                      }, null, 10, _hoisted_17),
                      _createElementVNode("p", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          class: "underline text-success",
                          to: {
                        name: 'users-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.id), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                property: "active",
                width: _ctx.calcWidth(100)
              }, {
                header: _withCtx(() => [
                  _hoisted_19
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_20, [
                      (scope.row.active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Да "))
                        : _createCommentVNode("", true)
                    ]),
                    (scope.row.is_banned)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                          _createVNode(_component_el_tooltip, {
                            placement: "top",
                            content: 
                      scope.row.banned_at
                        ? `Заблокирован: ${scope.row.banned_at}`
                        : 'Дата блокировки неизвестна'
                    
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                label: "PRO",
                width: _ctx.calcWidth(70)
              }, {
                header: _withCtx(() => [
                  _hoisted_24
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_25, [
                      (scope.row.account_pro)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " PRO "))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: 
              _ctx.calcWidth(
                _ctx.maxEmailColumnWidth > _ctx.nameColumnWidth
                  ? _ctx.maxEmailColumnWidth
                  : _ctx.nameColumnWidth
              )
            
              }, {
                header: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "p-2 mb-0 text-center cursor-pointer",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortTheColumn('last_name')))
                  }, [
                    _hoisted_27,
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi fs-1x", [
                    _ctx.sortState.id.dir ? 'bi-sort-up' : 'bi-sort-down',
                    _ctx.currentSort === 'last_name' || _ctx.currentSort === '-last_name'
                      ? 'text-success'
                      : 'opacity-25 text-black',
                  ]])
                    }, null, 2)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.photo && !_ctx.isEmptyObject(scope.row.photo))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_vue_easy_lightbox, {
                            scrollDisabled: false,
                            visible: scope.row.lightboxVisible,
                            imgs: scope.row.photo.path,
                            onHide: ($event: any) => (_ctx.closeLightbox(scope.$index))
                          }, null, 8, ["visible", "imgs", "onHide"]),
                          _createVNode(_component_el_image, {
                            style: {"width":"250px","height":"auto","cursor":"pointer"},
                            src: scope.row.photo.path,
                            onClick: ($event: any) => (_ctx.toggleLightbox(scope.$index))
                          }, null, 8, ["src", "onClick"])
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      class: "leading-2 mt-3",
                      innerHTML: 
                    _ctx.convertFullName(
                      scope.row.name,
                      scope.row.second_name,
                      scope.row.last_name
                    )
                  
                    }, null, 8, _hoisted_28),
                    _createElementVNode("table", _hoisted_29, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, [
                            _createVNode(_component_router_link, {
                              class: "underline text-success d-flex align-items-center",
                              to: {
                            name: 'users-edit',
                            params: {
                              id: scope.row.id,
                              entry: JSON.stringify(scope.row),
                            },
                          }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32,
                                _createElementVNode("span", _hoisted_33, _toDisplayString(scope.row.email), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, [
                            _hoisted_36,
                            _createVNode(_component_BasePhoneText, {
                              modelValue: scope.row.phone,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.phone) = $event),
                              class: "mb-0",
                              style: {"padding-left":"6px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("p", _hoisted_38, [
                            _createVNode(_component_router_link, {
                              class: "underline text-success",
                              to: {
                            name: 'ads-list',
                            query: {
                              page: 1,
                              limit: 10,
                              'filter[status]': 'all',
                              'filter[user_id]': scope.row.id,
                            },
                          },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_39
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_40,
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("p", _hoisted_42, _toDisplayString(scope.row.registered_at), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_43,
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_44, _toDisplayString(scope.row.last_update), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_45,
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_46, _toDisplayString(scope.row.last_login), 1)
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 align-top",
                width: _ctx.calcWidth(500)
              }, {
                header: _withCtx(() => [
                  _hoisted_47
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_el_checkbox_group, {
                        class: "my-2",
                        size: "small",
                        modelValue: scope.row.reasons,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.reasons) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reasonItem, reasonIndex) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: reasonIndex,
                              label: reasonItem,
                              class: "mb-2",
                              onChange: ($event: any) => (_ctx.checkItemOnReasonSelect(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reasonItem.value.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "onChange"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог одобрений ${
                        scope.row.approved_log
                          ? scope.row.approved_log.count
                          : '0'
                      }`
                    ,
                          name: "1"
                        }, {
                          default: _withCtx(() => [
                            (
                        scope.row.approved_log && scope.row.approved_log.count
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  (
                          scope.row.approved_log.log &&
                            scope.row.approved_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        _hoisted_51,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approved_log
                              .log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("a", _hoisted_52, [
                                                    _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог отклонений ${
                        scope.row.rejected_log
                          ? scope.row.rejected_log.count
                          : '0'
                      }`
                    ,
                          name: "2"
                        }, {
                          default: _withCtx(() => [
                            (
                        scope.row.rejected_log && scope.row.rejected_log.count
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createElementVNode("p", null, " отменено раз: " + _toDisplayString(scope.row.rejected_log.count), 1),
                                  (
                          scope.row.rejected_log.log &&
                            scope.row.rejected_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                        _hoisted_58,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.rejected_log
                              .log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_59, _toDisplayString(reason.text), 1),
                                                  _createElementVNode("a", _hoisted_60, [
                                                    _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(_ctx.maxEmailColumnWidth)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "p-2 mb-0 cursor-pointer text-center",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortTheColumn('email')))
                  }, [
                    _hoisted_64,
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi fs-1x text-black", {
                    'bi-sort-up': _ctx.sortState.email.dir,
                    'bi-sort-down': !_ctx.sortState.email.dir,
                    'opacity-25':
                      _ctx.currentSort !== 'email' && _ctx.currentSort !== '-email',
                  }])
                    }, null, 2)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_65, [
                      _createVNode(_component_router_link, {
                        class: "underline text-success",
                        to: {
                      name: 'users-edit',
                      params: {
                        id: scope.row.id,
                        entry: JSON.stringify(scope.row),
                      },
                    }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.email), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _hoisted_66
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_67, _toDisplayString(scope.row.registered_at), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "p-2 mb-0 cursor-pointer d-flex justify-content-center align-items-center leading-2",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortTheColumn('last_login')))
                  }, [
                    _hoisted_68,
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi fs-1x text-black ml-1", [
                    _ctx.sortState['last_login'].dir ? 'bi-sort-up' : 'bi-sort-down',
                    _ctx.currentSort === 'last_login' ||
                    _ctx.currentSort === '-last_login'
                      ? 'text-success'
                      : 'opacity-25 text-black',
                  ]])
                    }, null, 2)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_69, _toDisplayString(scope.row.last_login), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "p-2 mb-0 cursor-pointer text-center",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortTheColumn('last_update')))
                  }, [
                    _hoisted_70,
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi fs-1x text-black", [
                    _ctx.sortState['last_update'].dir
                      ? 'bi-sort-up'
                      : 'bi-sort-down',
                    _ctx.currentSort === 'last_update' ||
                    _ctx.currentSort === '-last_update'
                      ? 'text-success'
                      : 'opacity-25 text-black',
                  ]])
                    }, null, 2)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_71, _toDisplayString(scope.row.last_update), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _hoisted_72
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _hoisted_73,
                    _createElementVNode("p", _hoisted_74, [
                      _hoisted_75,
                      _createElementVNode("span", null, _toDisplayString(scope.row.stats.ads.active), 1)
                    ]),
                    _createElementVNode("p", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", null, _toDisplayString(scope.row.stats.ads.rejected), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(500)
              }, {
                header: _withCtx(() => [
                  _hoisted_78
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", {
                      class: "mb-0 pl-2 w-100 leading-1",
                      innerHTML: scope.row.admin_notes
                    }, null, 8, _hoisted_79)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                width: _ctx.calcWidth(60)
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createVNode(_component_el_button_group, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
                          title: "Одобрить пользователя",
                          onClick: ($event: any) => (_ctx.allowEntry(scope.row))
                        }, _hoisted_82, 8, _hoisted_80),
                        _createElementVNode("button", _hoisted_83, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'users-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_84
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", _hoisted_85, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'ads-list',
                        query: {
                          page: 1,
                          limit: 10,
                          'filter[status]': 'all',
                          'filter[user_id]': scope.row.id,
                        },
                      },
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_86
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
                          title: "Отклонить пользователя",
                          disabled: scope.row.reasons.length ? false : true,
                          onClick: ($event: any) => (_ctx.rejectEntry(scope.row))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi bi-x-circle-fill fs-3", {
                        'text-warning': scope.row.reasons.length,
                      }])
                          }, null, 2)
                        ], 8, _hoisted_87),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
                          title: "Войти в аккаунт пользователя",
                          onClick: ($event: any) => (_ctx.impersonateEntry(scope.row))
                        }, _hoisted_90, 8, _hoisted_88)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.isLoading]
          ]),
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.allowEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_92
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "warning",
                  title: _ctx.rejectButtonTitle,
                  disabled: _ctx.bulkRejectStatus,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.rejectEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_93
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_94
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.resetPasswordBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_95
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sentAccountConfirmLinkBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_96
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Добавить тариф выбранным пользователям'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openTariffDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_97
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Заблокировать пользователей'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.banEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_98
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.tariffDialogVisible,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.tariffDialogVisible) = $event)),
            title: "Добавить тариф",
            width: "520px",
            onClosed: _ctx.resetTariffForm
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.tariffDialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_107
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.tariffSubmitting,
                disabled: !_ctx.tariffForm.tariffId || !_ctx.tariffForm.termValue,
                onClick: _ctx.applyTariff
              }, {
                default: _withCtx(() => [
                  _hoisted_108
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                onSubmit: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "Режим" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.tariffForm.mode,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tariffForm.mode) = $event)),
                        class: "tariff-modes"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "extend" }, {
                            default: _withCtx(() => [
                              _hoisted_99,
                              _hoisted_100
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "replace" }, {
                            default: _withCtx(() => [
                              _hoisted_101,
                              _hoisted_102
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "correct" }, {
                            default: _withCtx(() => [
                              _hoisted_103,
                              _hoisted_104
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Тариф" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.tariffForm.tariffId,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tariffForm.tariffId) = $event)),
                        class: "w-100",
                        placeholder: "Выберите тариф",
                        filterable: "",
                        loading: _ctx.tariffsLoading
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffs, (tariff) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: tariff.id,
                              label: tariff.name,
                              value: tariff.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Тип периода" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.tariffForm.termUnit,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tariffForm.termUnit) = $event)),
                        class: "tariff-radios"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "day" }, {
                            default: _withCtx(() => [
                              _hoisted_105
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "month" }, {
                            default: _withCtx(() => [
                              _hoisted_106
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Срок" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.tariffForm.termValue,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tariffForm.termValue) = $event)),
                        min: 1,
                        max: _ctx.tariffForm.termUnit === 'day' ? 3650 : 120,
                        step: 1,
                        "step-strictly": ""
                      }, null, 8, ["modelValue", "max"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onClosed"])
        ]),
        _: 1
      }, 8, ["onFilterUsersButtonClick", "items-total", "pages-total", "current-page"])
    ])
  ]))
}